import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "experience" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "experience__container inner" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "experience__ttl vertical-ttl" }, [
    /*#__PURE__*/_createTextVNode(" まずは "),
    /*#__PURE__*/_createElementVNode("span", null, "体感"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("作ってみよう ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "experience__description" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "experience__sub-ttl" }, [
      /*#__PURE__*/_createTextVNode(" フォトアルバム付きバースデーメッセージのVRを "),
      /*#__PURE__*/_createElementVNode("br", { class: "is-pc" }),
      /*#__PURE__*/_createTextVNode("作ってみましょう。 ")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "experience__txt" }, [
      /*#__PURE__*/_createElementVNode("span", null, "01"),
      /*#__PURE__*/_createTextVNode(" 「HAPPY BIRTHDAY」を伝えたい人との想い出の写真データを4点ほどご準備ください。 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", null, "02"),
      /*#__PURE__*/_createTextVNode(" BLOCKVROCKで実際に作ってみましょう。 "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("span", null, "03"),
      /*#__PURE__*/_createTextVNode(" 完成したVRのURLまたはQRコードを、お祝いしたい人に贈りましょう。 ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "experience__video-wrapper" }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        src: "https://www.youtube.com/embed/IKy1RBKTdCY",
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://github.com/levelenter/blockvrock_doc/blob/BirthdayCard/template/BirthdayCard.md",
      class: "experience__guide",
      target: "_blank"
    }, "詳しい作り方ガイドを見る")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}